export default "__VITE_ASSET__CkhbahzJ__"